<template>
	<!-- 监理周报 -->
	<div class="mod-config">
		<el-card body-style="padding-bottom: 0;" style="margin-top: -5px;">
			<div class="title">监理月报</div>
			<div class="line"></div>
			<el-row style="margin-bottom: 5px;">
				<el-col :span="pageSpan">
					<el-button v-preventReClick class="btn" type="primary" size="small" @click="addOrUpdateHandle()">
						创建</el-button>
				</el-col>
			</el-row>
		</el-card>
		<div>
			<el-card style="margin-top: -3px;" body-style="padding: 0;">
				<el-row style="margin-bottom: 10px;">
					<el-col :span="24">
						<div class="box">
							<el-table :height="screenHeight - 206 + 'px'" :row-class-name="tableRowClassName"
								class="dataListTable" border :data="dataList" header-align="center"
								style="width: 100%; margin-bottom: 20px;" header-cell-class-name="dataListTHeader"
								:cell-style="{ padding: '0px' }">
								<el-table-column type="index" label="NO." width="60" align="center">
									<template slot-scope="scope">{{ (pageIndex2 - 1) * limit + scope.$index + 1
									}}</template>
								</el-table-column>
								<el-table-column prop="monthlyName" label="编号" min-width="200" align="center">
									<template slot-scope="scope">
										<el-button v-preventReClick type="text" size="small"
											@click="viewPdf(scope.row.filePath, scope.row.filePathUri, scope.row.monthlyName)">{{
												scope.row.monthlyName }}</el-button>
									</template>
								</el-table-column>
								<el-table-column label="日期" min-width="200" align="center">
									<template slot-scope="scope">
										{{ scope.row.beginTime }} 至 {{ scope.row.endTime }}
									</template>
								</el-table-column>
								<el-table-column prop="refirmMan" label="确认人" width="110" align="center">
								</el-table-column>
								<el-table-column prop="refirmTime" label="确认时间" width="110" align="center">
								</el-table-column>
								<el-table-column label="编辑版" width="220" fixed="right" v-if="showDelete || showEdit"
									align="left">
									<template slot-scope="scope">
										<!-- <el-button v-preventReClick type="text" size="small"
											@click="viewPdf(scope.row.filePath, scope.row.filePathUri, scope.row.monthlyName)">查看</el-button> -->
										<el-button v-preventReClick type="text" size="small"
											v-if="scope.row.refirmFlg != '1'"
											@click="editHandle(scope.row.recNo)">编辑</el-button>
										<el-button v-preventReClick type="text" size="small"
											@click="createHandle(scope.row.recNo)"
											v-if="(scope.row.monthlyStatus === '1' || !scope.row.monthlyStatus) && scope.row.refirmFlg !== '1'">
											生成</el-button>
										<el-button v-preventReClick type="text" size="small"
											@click="downloadHandle(scope.row.recNo)"
											v-if="showRowDownload">下载</el-button>
										<el-button v-preventReClick type="text" size="small"
											@click="zipDownLoadProjectMonthly(scope.row)"
											v-if="showRowDownload">打包下载</el-button>
										<el-button v-preventReClick type="text" size="small"
											@click="deleteHandle(scope.row.recNo)"
											v-if="showDelete && scope.row.refirmFlg != '1'">删除</el-button>
									</template>
								</el-table-column>
								<el-table-column label="线下版" width="110" fixed="right" align="center">
									<template slot-scope="scope">
										<el-button v-preventReClick type="text" size="small"
											v-if="scope.row.refirmFlg != '1'"
											@click="uploadOfflineFileHandle(scope.row.recNo)">上传</el-button>
										<!-- <el-button v-preventReClick type="text" size="small"
											v-if="scope.row.offlineFilePath != undefined && scope.row.offlineFilePath != ''"
											@click="viewPdf(scope.row.offlineFilePath, scope.row.offlineFilePathUri, scope.row.monthlyName)">查看</el-button> -->
										<el-button v-preventReClick type="text" size="small"
											v-if="scope.row.offlineFilePath != undefined && scope.row.offlineFilePath != ''"
											@click="offlineFileDownloadHandle(scope.row.recNo)">查看</el-button>
									</template>
								</el-table-column>
								<el-table-column label="状态" width="80" fixed="right" align="center">
									<template slot-scope="scope">
										{{ getStatusLabel(scope.row.refirmFlg) }}
									</template>
								</el-table-column>
								<el-table-column label="审核" min-width="80" fixed="right" align="center">
									<template slot-scope="scope">
										<el-button v-preventReClick type="text" size="small"
											@click="refirmHandle(scope.row.recNo, scope.row.refirmMan, scope.row.refirmTime)"
											v-if="scope.row.refirmFlg === '' || scope.row.refirmFlg == undefined || scope.row.refirmFlg == '0'">确认</el-button>
										<el-button v-preventReClick type="text" size="small"
											@click="cancelRefirmHandle(scope.row.recNo)"
											v-if="scope.row.refirmFlg === '1'">取消</el-button>
									</template>
								</el-table-column>
								<el-table-column label="" width="100" fixed="right" align="left">
									<template slot-scope="scope">
										<el-button v-preventReClick type="text" size="small"
											@click="addProjectHandOver(scope.row)"
											v-if="scope.row.refirmFlg === '1' && scope.row.offlineFilePath != undefined && scope.row.offlineFilePath != ''">
											加入交接清单</el-button>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<el-pagination class="my-pagination" @size-change="sizeChangeHandle"
							@current-change="currentChangeHandle" :current-page="page" :page-sizes="[10, 20, 50, 100]"
							:page-size="limit" :total="totalCount" layout="total, sizes, prev, pager, next, jumper">
						</el-pagination>
					</el-col>
				</el-row>
			</el-card>
		</div>

		<!-- <el-dialog title="线下版文件上传" :visible.sync="uploadOfflineFileVisible" width="30%" :close-on-click-modal="false">
			<el-form>
				<el-row>
					<el-col :span="6">
						<div class="item">
							线下版文件
						</div>
					</el-col>
					<el-col :span="14">
						<el-upload v-if="!uploadOfflineFile.uploadOfflineFilePath" ref="uploadMonthlyOfflineFile"
							class="upload-demo" action="action" drag :http-request="uploadMonthlyOfflineFile"
							:show-file-list=false :auto-upload="true" style="margin-left: 10px;">
							<i class="el-icon-upload"></i>
							<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
						</el-upload>
						<div v-if="uploadOfflineFile.uploadOfflineFilePath" style="margin-left: 10px;">
							<el-button v-preventReClick type="success" size="small" @click="downloadFile(
								uploadOfflineFile.uploadOfflineFileUri, uploadOfflineFile.uploadOfflineFileName)">查看</el-button>
							<el-button v-preventReClick type="primary" size="small"
								@click="delOfflineFile()">删除</el-button>
						</div>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button v-preventReClick class="btn" type="primary" size="small"
					@click="updateOfflineFile()">保存</el-button>
				<el-button v-preventReClick class="rebtn" size="small" @click="uploadOfflineFileVisible = false">取
					消</el-button>
			</span>
		</el-dialog> -->

		<add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
		<project-monthly-refirm v-if="refirmVisible" ref="projectMonthlyRefirm"
			@refreshDataList="getDataList"></project-monthly-refirm>
		<view-pdf v-if="viewPdfVisible" ref="viewPdf" @refreshDataList="dataList"></view-pdf>
		<project-monthly-report-download v-if="downloadVisible" ref="projectMonthlyReportDownload"
			@refreshDataList="getDataList"></project-monthly-report-download>
		<monthly-offline-download v-if="monthlyOfflineDownloadVisible" ref="monthlyOfflineDownload"
			@refreshDataList="getDataList"></monthly-offline-download>
		<monthly-offline-upload v-if="monthlyOfflineUploadVisible" ref="weeklyOfflineUpload"
			@refreshDataList="getDataList"></monthly-offline-upload>
	</div>
</template>
<script>
import AddOrUpdate from './project-monthly-add-or-update.vue'
import $common from "@/utils/common.js"
import ProjectMonthlyRefirm from "./project_monthly_refirm.vue"
import ViewPdf from "../projectInfo/viewPdf.vue"
import ProjectMonthlyReportDownload from "./project-monthly-report-download.vue"
import MonthlyOfflineDownload from "./project-monthly-offline-download.vue"
import MonthlyOfflineUpload from "./project-monthly-offline-upload.vue"
export default {
	data() {
		return {
			viewPdfVisible: false,
			showSearch: false,
			showDownload: false,
			showAdd: false,
			showEdit: false,
			showDelete: false,
			showCheck: false,
			action: '',
			showArchive: false,
			showRowDownload: false,
			pageSpan: 12,
			refirmVisible: false,
			addOrUpdateVisible: false,
			enclosureVisible: false,
			reportUploadVisible: false,
			downloadVisible: false,
			monthlyOfflineDownloadVisible: false,
			monthlyOfflineUploadVisible: false,
			form: {},
			limit: 20,
			page: 1,
			totalCount: 0,
			screenHeight: 0,
			dataList: [],
			tableSelVal: [],
			// 显示序号
			pageIndex2: 1,
			uploadRecNo: '',
			uploadOfflineFileName: '',
			uploadOfflineFileVisible: false,
			uploadOfflineFile: {
				uploadOfflineFilePath: '',
				uploadOfflineFileUri: '',
				uploadOfflineFileName: ''
			},
		};
	},
	components: {
		AddOrUpdate,
		ProjectMonthlyRefirm,
		ViewPdf,
		ProjectMonthlyReportDownload,
		MonthlyOfflineDownload,
		MonthlyOfflineUpload
	},
	mounted() {
		this.screenHeight = window.innerHeight
		this.showSearch = $common.isAuth('monthly:search');
		this.showDownload = $common.isAuth('monthly:download');
		this.showAdd = $common.isAuth('monthly:add');
		this.showEdit = $common.isAuth('monthly:edit');
		this.showDelete = $common.isAuth('monthly:delete');
		this.showCheck = $common.isAuth('monthly:check');
		this.showArchive = $common.isAuth('monthly:archive');
		this.showRowDownload = $common.isAuth('monthly:download');
		if (!this.showSearch && !this.showDownload && !this.showAdd) {
			this.pageSpan = 24;
		}
		this.getDataList();
	},
	methods: {
		getStatusLabel(refirmFlg) {
			if (refirmFlg == '0' || refirmFlg == null || refirmFlg == '') {
				return '编辑中';
			}
			return '已审核';
		},
		// uploadOfflineFileHandle(row) {
		// 	this.uploadRecNo = row.recNo
		// 	this.uploadOfflineFileName = row.monthlyName
		// 	this.uploadOfflineFile = {
		// 		uploadOfflineFilePath: row.offlineFilePath,
		// 		uploadOfflineFileUri: row.offlineFilePathUri,
		// 		uploadOfflineFileName: row.monthlyName
		// 	}
		// 	this.uploadOfflineFileVisible = true
		// },
		// uploadMonthlyOfflineFile(param) {
		// 	const formData = new FormData();
		// 	formData.append('file', param.file);
		// 	this.$refs.uploadMonthlyOfflineFile.clearFiles();
		// 	this.$http.post(
		// 		this.$store.state.httpUrl + "/file/upload/" + $common.getItem("workNo") + "/90/0",
		// 		formData,
		// 		{
		// 			headers: { 'Content-Type': 'multipart/form-data' }
		// 		},
		// 	).then(res => {
		// 		res = res.data;
		// 		if (res.resultCode === 200) {
		// 			this.uploadOfflineFile = {
		// 				uploadOfflineFilePath: res.body.fileSavePath,
		// 				uploadOfflineFileUri: res.body.fileUri,
		// 				uploadOfflineFileName: this.uploadFileName
		// 			}
		// 		} else {
		// 			this.$message.info('文件上传失败')
		// 		}
		// 	})
		// },
		// delOfflineFile() {
		// 	this.uploadOfflineFile = {
		// 		uploadOfflineFilePath: '',
		// 		uploadOfflineFileUri: '',
		// 	}
		// },
		viewPdf(filePath, fileUri, filename) {
			if (filePath == null || filePath == undefined || filePath == '') {
				this.$message.error("没有可预览的文件！");
				return;
			}
			// pdf和doc文件，需要pdf在线预览，其他类型文件直接下载
			let suffixType = fileUri.substr(fileUri.lastIndexOf(".") + 1)
			if (suffixType != '' && (suffixType === 'pdf' || suffixType === 'doc' || suffixType === 'docx')) {
				// $common.viewFile(filePath)
				this.viewPdfVisible = true;
				this.$nextTick(() => {
					this.$refs.viewPdf.init(filename, filePath)
				})
			} else {
				filename = this.getSuffix(fileUri, filename)
				this.getBlob(fileUri, (blob) => {
					this.saveAs(blob, filename)
				})
			}
		},
		getSuffix(url, filename) {
			let lastIndex = url.lastIndexOf(".");
			return filename + url.substr(lastIndex)
		},
		getBlob(url, cb) {
			var xhr = new XMLHttpRequest()
			xhr.open('GET', url, true)
			xhr.responseType = 'blob'
			xhr.onload = function () {
				if (xhr.status === 200) {
					cb(xhr.response)
				}
			}
			xhr.send()
		},
		saveAs(blob, filename) {
			if (window.navigator.msSaveOrOpenBlob) {
				navigator.msSaveBlob(blob, filename)
			}
			else {
				var link = document.createElement('a')
				var body = document.querySelector('body')

				link.href = window.URL.createObjectURL(blob)
				link.download = filename

				link.style.display = 'none'
				body.appendChild(link)

				link.click()
				body.removeChild(link)
				window.URL.revokeObjectURL(link.href)
			}
		},
		refirmHandle(id, refirmMan, refrimTime) {
			this.refirmVisible = true
			this.$nextTick(() => {
				this.$refs.projectMonthlyRefirm.init(id, refirmMan, refrimTime)
			})
		},
		cancelRefirmHandle(id) {
			this.$confirm(`确定对选中的数据进行解除确认操作?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: this.$store.state.httpUrl + "/business/projectmonthlyreportinfo/cancelProjectMonthlyRefirm/" + id,
					method: "post",
					data: {},
				}).then(({ data }) => {
					if (data && data.resultCode === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.getDataList()
							}
						})
					}
				});
			})
		},
		downloadHandle(id) {
			this.downloadVisible = true;
			this.$nextTick(() => {
				this.$refs.projectMonthlyReportDownload.init(id)
			})
		},
		// 打包下载
		zipDownLoadProjectMonthly(item) {
			var fileName = item.fileName + ".zip";
			this.$http({
				url: this.$store.state.httpUrl + "/business/projectmonthlyreportinfo/zipDownLoadProjectMonthly?recNo=" + item.recNo,
				method: "POST",
				data: {},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: '操作成功',
						type: 'success',
						duration: 1500,
						onClose: () => {
							this.global.downLoadFile(data.body, fileName);
						}
					})
				}
			});
		},
		//重置
		resetFormData() {
			this.pageIndex = 1;
			this.getDataList();
		},
		getDataList() {
			if (this.showSearch) {
				this.$http({
					url: this.$store.state.httpUrl + "/business/projectmonthlyreportinfo/list",
					method: 'get',
					params: this.$http.adornParams({
						limit: this.limit,
						page: this.page,
						workNo: $common.getItem("workNo")
					})
				}).then(({ data }) => {
					if (data && data.resultCode === 200) {
						this.dataList = data.body.records;
						this.totalCount = data.body.totalCount;
						this.pageIndex2 = this.page
					} else {
						this.dataList = []
						this.totalCount = 0
						this.pageIndex2 = 1
					}
				})
			}
		},
		uploadOfflineFileHandle(id) {
			this.monthlyOfflineUploadVisible = true
			this.$nextTick(() => {
				this.$refs.weeklyOfflineUpload.init(id)
			})
		},
		offlineFileDownloadHandle(id) {
			this.monthlyOfflineDownloadVisible = true
			this.$nextTick(() => {
				this.$refs.monthlyOfflineDownload.init(id)
			})
		},
		createHandle(id) {
			this.$confirm(`确定对选中的数据进行生成月报吗?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: this.$store.state.httpUrl + "/business/projectmonthlyreportinfo/downloadProjectMonthly/" + id,
					method: "POST",
					data: {},
				}).then(({ data }) => {
					if (data && data.resultCode === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.getDataList()
							}
						})
					}
				});
			})
		},
		//删除
		deleteHandle(id) {
			this.$confirm(`确定对选中的数据进行删除操作?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: this.$store.state.httpUrl + "/business/projectmonthlyreportinfo/delete/" + id,
					method: "post",
					data: {},
				}).then(({ data }) => {
					if (data && data.resultCode === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.getDataList()
							}
						})
					}
				});
			})
		},
		siteContentViewHeight() {
			var height = this.$store.state.common.documentClientHeight - 190;
			return { height: height + 'px' }
		},
		handleSelectionChange(val) {
			this.tableSelVal = val;
		},
		tableRowClassName({ row, rowIndex }) {
			return $common.tableRowClassName({ row, rowIndex });
		},
		// 每页数
		sizeChangeHandle(val) {
			this.limit = val
			this.page = 1
			this.getDataList()
		},
		// 当前页
		currentChangeHandle(val) {
			this.page = val
			this.getDataList()
		},
		addOrUpdateHandle(id) {
			this.addOrUpdateVisible = true;
			this.$nextTick(() => {
				this.$refs.addOrUpdate.init(id);
			})
		},
		editHandle(id) {
			this.$router.push({ name: 'projectMonthlyExportInfo', query: { recNo: id } });
		},
		downloadFile(fileUri, filename) {
			filename = this.getSuffix(fileUri, filename)
			this.getBlob(fileUri, (blob) => {
				this.saveAs(blob, filename)
			})
		},
		updateOfflineFile() {
			// if (this.uploadOfflineFile.uploadOfflineFilePath == undefined || this.uploadOfflineFile.uploadOfflineFilePath == '') {
			// 	this.$message.error("请上传签字版文件！")
			// 	return
			// }
			this.$http({
				url: this.$store.state.httpUrl + "/business/projectmonthlyreportinfo/uploadOfflineFile",
				method: 'post',
				params: this.$http.adornParams({
					recNo: this.uploadRecNo,
					offlineFilePath: this.uploadOfflineFile.uploadOfflineFilePath,
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: '操作成功',
						type: 'success',
						duration: 1500,
						onClose: () => {
							this.uploadOfflineFileVisible = false;
							this.uploadOfflineFile = {
								uploadOfflineFilePath: '',
								uploadOfflineFileUri: '',
								uploadOfflineFileName: ''
							}
							this.getDataList()
						}
					})
				}
			})
		},
		addProjectHandOver(item) {
			const _url = "/business/projecthandoverlist/save";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData({
					workNo: $common.getItem("workNo"),
					fileName: item.monthlyName,
					templatePath: item.offlineFilePath
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
					});
				} else {
					this.$message.error(data.msg);
				}
			});
		},
	}
};
</script>
<style lang="scss" scoped="scoped">
.selItemText {
	font-size: 14px;
	color: #1c1c1c;
	display: inline-block;
	width: 80px;
}

.my-pagination {
	margin-right: 20px !important;
}

// 设置表头样式
::v-deep(.el-table th.el-table__cell) {
	font-size: 15px;
	padding: 2px 0;
}

::v-deep(.upload-demo .el-upload-dragger) {
	width: 200px;
	height: 80px;
}

::v-deep(.upload-demo .el-upload-dragger .el-icon-upload) {
	font-size: 30px;
	margin: 12px 1px;
	line-height: 20px;
}

::v-deep(.upload-demo .el-upload-dragger .el-upload__text) {
	line-height: 5px;
}
</style>
